import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=eeff6eb2&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=js"
export * from "./resetPwd.vue?vue&type=script&lang=js"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=eeff6eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeff6eb2",
  null
  
)

export default component.exports